import moment from 'moment';
export const momentjs = () => moment;
export function getMoment(date) {
    return date !== undefined ? moment(date) : moment();
}
export function getDuration(startDate, endDate) {
    const diffDuration = moment.duration(moment(endDate).diff(moment(startDate)));
    const hours = diffDuration.hours();
    const minutes = diffDuration.minutes();
    const seconds = diffDuration.seconds();
    const parts = [];
    if (hours > 0)
        parts.push(`${hours} hours`);
    if (minutes > 0)
        parts.push(`${minutes} minutes`);
    if (seconds > 0)
        parts.push(`${seconds} seconds`);
    return parts.length > 0 ? parts.join(', ') : '0 seconds';
}
export function getTime(date) {
    return moment(date).format('HH:mm:ss');
}
export function convertToLocalTimezone(date, includeTime = true) {
    const local = moment.utc(date).local();
    if (!local.isValid())
        return '';
    const options = includeTime
        ? {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }
        : { year: 'numeric', month: '2-digit', day: '2-digit' };
    return local.toDate().toLocaleString(undefined, options);
}
